import React, { useState, useEffect } from "react";
import { formatCheckoutPrice } from "~/assets/js/Format";
import i18n from "~/assets/js/Helpers/i18n";
import Button from "~/assets/js/components/Button";
import useSmoothScroll from "~assets/js/Helpers/hooks/useSmoothScroll";
import PropTypes from "prop-types";
import { PlusCircle } from "react-feather";
import { useCartContext } from "~/assets/js/global/cartContext";

const FreeDeliveryNotification = ({
    totals = 0,
    threshold,
    label = "cart.freeDelivery.title",
}) => {
    const { cart } = useCartContext();
    const [amountRemaining, setAmountRemaining] = useState(false);

    useEffect(() => {
        setAmountRemaining(calculateAmountRemaining());
    }, [totals, threshold]);

    const calculateEnvCompesation = () => {
        const compensation = cart.compensation?.level;
        switch (compensation) {
            case "single":
                return parseFloat(
                    cart.compensation.predicted_values.single.value_gross
                );
            case "double":
                return parseFloat(
                    cart.compensation.predicted_values.double.value_gross
                );
            case "none":
                return 0;
            default:
                return 0;
        }
    };

    const calculateAmountRemaining = () => {
        const currentTotal = parseFloat(totals) - calculateEnvCompesation();
        const remainingAmount = threshold - currentTotal;

        // Hide notification if threshold is achieved
        if (remainingAmount <= 0) {
            return false;
        }

        return formatCheckoutPrice(remainingAmount, 0, "€"); //TODO get currency from cart
    };

    const handleOnClick = () => useSmoothScroll("complementary-products");

    if (amountRemaining) {
        return (
            <div className="cart-box">
                <div className="cart-box__image">
                    <PlusCircle stroke="#00E940" />
                </div>
                <div className="cart-box__content">
                    <div className="cart-box__header">
                        <h5 className="cart-box__title">
                            {i18n.t(label, {
                                amount: amountRemaining,
                            })}
                        </h5>
                    </div>

                    <p className="cart-box__text">
                        {i18n.t("cart.freeDelivery.text")}
                    </p>
                    <div className="cart-box__action">
                        <Button
                            label={i18n.t("cart.freeDelivery.CTA")}
                            onClick={handleOnClick}
                            variant="secondary"
                            size="XS"
                        />
                    </div>
                </div>
            </div>
        );
    } else {
        return null;
    }
};

FreeDeliveryNotification.propTypes = {
    totals: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    threshold: PropTypes.number,
};

export default FreeDeliveryNotification;
